import React, { useEffect, useState } from "react";
import style from "./plotShape.module.css";
import PageHeader from "../../../components/pageHeader/pageHeader"
import Input from "../../../components/Input";
import DataTable from 'react-data-table-component';
import Sorting from '../../../assets/images/svgs/alphabetical-sorting.svg';
import Table, { tableCustomStyles } from "../../../components/CommonComponents/Table/Table";
import axios from "axios";
import { ErrorToast, SuccessToast } from "../../../components/toastMessage";
import { BASE_URL } from "../../../constants/Constants";
import { useNavigate } from "react-router-dom";
import Dropdown from 'react-bootstrap/Dropdown';
import { useDebounce } from "../../../hooks/common";
import Paginator, { PaginatorForRDT } from "../../../components/CommonComponents/Paginator/Paginator";
import { formatDate } from "../../../utils/date";
import Edit from "../../../assets/EditInWhite.svg"
import BoxComponent from "../../../components/CommonComponents/BoxComponent/BoxComponent";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import EditButton, { ViewButton } from "../../../components/CommonComponents/EditComponent/EditComponent";
import { _axios } from "../../../utils/axios";

const PlotShape = () => {
    const [currentPage, setCurrentPage] = useState(1);
    const [entriesPerPage, setEntriesPerPage] = useState(10);
    const [totalList, setTotalList] = useState(10);
    const [submittedDate, setSubmittedDate] = useState<string | null>(null);
    const [searchQuery, setSearchQuery] = useState("");
    const search = useDebounce(searchQuery);
    const [plotShapeList, setPlotShapeList] = useState([]);
    const [isGridView, setIsGridView] = useState(false);
    const [activeStatus, setActiveStatus] = useState(false);
    const [inactiveStatus, setInactiveStatus] = useState(false);
    const [lastDate, setLastDate] = useState<string | null>(null);
    const [selectedFilters, setSelectedFilters] = useState<string[]>([]);

    const navigate = useNavigate();

    const columns = [
        {
            name: 'Sr. No.',
            grow: 0.5,
            // selector: (row: any, rowIndex: number | undefined) =>
            //     (currentPage - 1) * entriesPerPage + (rowIndex ?? 0) + 1,
            selector: (log: any, rowIndex: number | undefined) => {
                const serialNumber = (currentPage - 1) * entriesPerPage + (rowIndex ?? 0) + 1;
                return serialNumber.toString().padStart(3, '0');
            },
            sortable: false,
        },
        {
            name: 'Plot Shape',
            selector: (row: any): any => (<div> <img height="30px" width="30px" alt="image" src={row.plot_shape} /> </div>),
            sortable: false,
        },
        {
            name: 'Last Publish Date',
            grow: 0.5,
            selector: (row: any) => formatDate(new Date(row.submitted_at)),
            sortable: true,
            width: "240px",
            sortFunction: (a: any, b: any) => {
                const dateA = new Date(a.submitted_at);
                const dateB = new Date(b.submitted_at);
                return dateA.getTime() - dateB.getTime();
            }
        },
        {
            name: 'Status',
            grow: 0.5,
            cell: (row: any) => (
                <button
                    className={row.status === 1 ? "activeButtonCss" : "inactiveButtonCss"}
                >
                    {row.status === 1 ? "Active" : "Inactive"}
                </button>
            ),
            sortable: false,
        },
        {
            name: 'Created By',
            selector: (row: any) => row.created_by,
            cell: (row: any) => <span className="text-center">{row.created_by}</span>,
            sortable: true,
            width: "170px",
        },
        {
            name: 'Created On',
            selector: (row: any) => formatDate(new Date(row.created_on)),
            sortable: true,
            width: "170px",
        },
        {
            name: 'Modified By',
            selector: (row: any) => row.modified_by,
            cell: (row: any) => <span className="text-center">{row.modified_by}</span>,
            sortable: true,
            width: "170px",
        },
        {
            name: 'Modified On',
            selector: (row: any) => formatDate(new Date(row.modified_on)),
            sortable: true,
            width: "170px",
        },
        {
            name: 'Action',
            grow: 0.5,
            cell: (row: any) => (
                <div className="flex space-x-2">
                    <EditButton
                        onClick={() => { navigate("/plot-details", { state: { documentData: row } }) }}
                    />
                    <ViewButton
                        disabled={true}
                        onClick={function (): void {
                            throw new Error("Function not implemented.");
                        }}
                    />
                </div>
            ),
            sortable: false,
        },
    ];

    const getShapeList = (date?: string | null) => {
        const requestBody: any = {
            "page": currentPage,
            "limit": entriesPerPage,
            filters: selectedFilters,
            lastDate
        };

        if (selectedFilters.length > 0) {
            requestBody.filters = selectedFilters;
        }

        if (date !== undefined) {
            if (date) {
                requestBody.lastDate = date;
            }
        } else if (lastDate) {
            requestBody.lastDate = lastDate;
        }

        _axios.post(`${BASE_URL}/api/plotshape`, requestBody)
            .then(function (response) {
                if (response?.data?.success === 0) {
                    ErrorToast(response?.data?.message)
                    return
                }
                setTotalList(response.data.data.total_rows)
                setPlotShapeList(response?.data?.data.results)
                console.log('res', response?.data?.data)
            })
            .catch(function (error) {
                if (error?.response?.data?.message) {
                    ErrorToast(error?.response?.data?.message)
                }
                console.log('error', error);
            })
    };

    useEffect(() => {
        getShapeList()
    }, [currentPage, entriesPerPage, selectedFilters, lastDate, selectedFilters])

    const handleFilterChange = (filter: string, value?: string | null) => {
        console.log("Filter:", filter);
        console.log("Value:", value);

        let filterValue;

        if (filter === "Active") {
            filterValue = "1";
        } else if (filter === "Inactive") {
            filterValue = "0";
        } else {
            filterValue = filter;
        }
        if (filter !== 'lastDate') {
            const index = selectedFilters.indexOf(filterValue);
            if (index === -1) {
                setSelectedFilters([...selectedFilters, filterValue]);
            } else {
                const updatedFilters = [...selectedFilters];
                updatedFilters.splice(index, 1);
                setSelectedFilters(updatedFilters);
            }
        }

    };

    const handleDateChange = (date: Date | null) => {
        if (date) {
            const adjustedDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
            const dateString = adjustedDate.toISOString().split('T')[0];
            setLastDate(dateString);
            getShapeList();
        } else {
            setLastDate(null);
        }
    };

    const dropdownContent = (
        <div className={style.dropdownBox}>
            <ul>
                <Dropdown.Menu show className="align-left">
                    <div className={style.dropContent}>
                        <Dropdown.Header className={style.DropHeader}>Plot Shape Filter</Dropdown.Header>
                        <div className={style.dropdownContent}>
                            <ul>
                                <li>
                                    <div className={style.dropdownCheck}>
                                        <input
                                            type="checkbox"
                                            className={style.checkBoxDrop}
                                            checked={selectedFilters.includes('1')}
                                            onChange={() => handleFilterChange("Active")}
                                        />{" "} <label >Active Status</label>
                                    </div>
                                </li>
                                <li>
                                    <div className={style.dropdownCheck}>
                                        <input
                                            type="checkbox"
                                            className={style.checkBoxDrop}
                                            checked={selectedFilters.includes('0')}
                                            onChange={() => handleFilterChange("Inactive")}
                                        />{" "}Inactive Status
                                    </div>
                                </li>
                                <li>
                                    <span className="text-sm pl-2"> Last Publish Date</span>
                                    <DatePicker
                                        selected={lastDate ? new Date(lastDate) : null} // Convert string to Date object
                                        onChange={handleDateChange}
                                        dateFormat="dd/MM/yyyy"
                                        className="border border-black"
                                        isClearable
                                    />
                                </li>

                            </ul>
                        </div>
                    </div>
                </Dropdown.Menu>
            </ul>
        </div>
    );

    const handlePageChange = (page: React.SetStateAction<number>) => {
        setCurrentPage(page);
    };

    return (
        <div className="p-8 overflow-auto">
            <PageHeader
                title="Plot Shape List"
                searchQuery={searchQuery}
                setSearchQuery={setSearchQuery}
                showSearchButton={false}
                showAdditionalButton={true}
                buttonTitle="Create Plot Shape"
                onClick={() => { navigate("/plot-details") }}
                isGridView={isGridView}
                onGridIconClick={() => setIsGridView(!isGridView)}
                showFilterButton={true}
                dropdownContent={dropdownContent}
            />

            {isGridView ? (
                <>
                    <BoxComponent>
                        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-3">
                            {plotShapeList?.filter(
                                (row: any) => row?.plot_shape.toLowerCase().includes(searchQuery.toLowerCase()))
                                .map((row: any) => {
                                    return (
                                        <div className="p-4 rounded-2xl bg-white flex flex-col shadow-lg border border-gray-300" key={row.id}>
                                            <div className="flex justify-between items-center space-x-4 mb-4">
                                                <button className={row.status === 1 ? "activeButtonCss" : "inactiveButtonCss"}>
                                                    {row.status === 1 ? "Active" : "Inactive"}
                                                </button>
                                                <div className="flex justify-center space-x-1">
                                                    <div className="flex space-x-2">
                                                        <EditButton
                                                            onClick={() => { navigate("/plot-details", { state: { documentData: row } }) }}
                                                        />
                                                        <ViewButton
                                                            disabled={true}
                                                            onClick={function (): void {
                                                                throw new Error("Function not implemented.");
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="d-flex justify-content-between">
                                                <div className="d-flex flex-column p-1">
                                                    <p className={'align-self-center'} style={{ marginBottom: '0px' }}><strong>Last Published Date</strong></p>
                                                    <p className={'align-left-center'} style={{ marginBottom: '0px' }}>{formatDate(new Date(row?.submitted_at)) ?? '09/06/2023'}</p>
                                                </div>
                                                <img src={row.plot_shape} alt="img" className={style.responsiveImage} />
                                            </div>
                                        </div>
                                    )
                                })
                            }
                        </div>
                        <Paginator
                            limit={entriesPerPage}
                            page={currentPage}
                            setPage={handlePageChange}
                            count={totalList}
                        />
                    </BoxComponent>
                </>
            ) : (
                <BoxComponent>
                    <Table
                        columns={columns}
                        data={plotShapeList}
                        paginationTotalRows={totalList || 0}
                        onChangePage={(p) => handlePageChange(p)}
                        customStyles={tableCustomStyles}
                        paginationComponent={PaginatorForRDT}
                    />
                </BoxComponent>
            )}
        </div>
    );
};

export default PlotShape;